import type { CSSProperties } from "react";

/**
 * Inline-style helpers for the few places that cannot use the classes in
 * src/styles/glass.css (a scrim built in a style object, a per-instance
 * tint). Always emits the -webkit- prefix Safari still needs.
 */

/** backdrop-filter with its -webkit- twin, for inline style objects. */
export function backdrop(filter: string): Pick<CSSProperties, "backdropFilter" | "WebkitBackdropFilter"> {
  return { backdropFilter: filter, WebkitBackdropFilter: filter };
}

/** Per-instance material tuning for a .glass element (tint 0..1, frost in px). */
export function glassVars({ tint, frost }: { tint?: number; frost?: number }): CSSProperties {
  const vars: Record<string, string> = {};
  if (tint != null) vars["--g-a"] = String(tint);
  if (frost != null) vars["--g-frost"] = `${frost}px`;
  return vars as CSSProperties;
}
